import * as React from 'react';

import type { Link } from 'bundles/ai-course-coach/store/types';

type Props = {
  message: Link;
};

function Snippet({ message }: Props) {
  return (
    <div className="coach-snippet">
      <h5 className="coach-snippet-title">{message.title}</h5>
      <div className="coach-snippet-details">
        <a href={message.link} target={message.target} className="coach-link">
          {message.link}
        </a>
      </div>
    </div>
  );
}

export default Snippet;
